import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import useAnimation from './hooks/useAnimation';

function PreventCapture() {
    const ref = useRef<HTMLDivElement>(null);
    const { t } = useTranslation('coupon');

    useAnimation(ref);
    return (
        <Wrapper>
            <Container ref={ref}>
                {Array.from({ length: 10 }).map((_, i) => (
                    <Item key={i.toString()} >
                        <ItemText color={colors.gray7}
                            fontWeight='medium'>
                            {t('detail.preventCapture')}
                        </ItemText>
                    </Item>
                ))}
            </Container>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    background-color: var(--color-surface-secondary);
    overflow: hidden;
    width: 100%;
`;

const Container = styled.div`
    display: flex;
    height: 32px;
`;

const Item = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    padding: 9px 20px;
    width: 180px;
`;

const ItemText = styled(Text)`
    font-size: 10px !important;
    line-height: 1.4;
    white-space: nowrap;
`;

export default PreventCapture;
